import React from 'react';
import { Clock, Play, Pause } from 'lucide-react';
import { formatTime } from '../../utils/timeUtils';

const Timer = ({ 
  time, 
  isRunning, 
  onToggle, 
  onReset, 
  theme = 'light',
  size = 'normal',
  showIcon = true,
  className = '',
  isExpired = false
}) => {
  const sizeClasses = {
    small: 'text-sm',
    normal: 'text-lg',
    large: 'text-xl'
  };

  const buttonSizeClasses = {
    small: 'p-0.5',
    normal: 'p-1', 
    large: 'p-2'
  };

  const iconSizes = {
    small: 12,
    normal: 14,
    large: 16
  };

  return (
    <div className={`flex items-center space-x-2 ${className}`}>
      {showIcon && (
        <Clock 
          className={`${theme === 'dark' ? 'text-gray-400' : 'text-gray-500'}`} 
          size={iconSizes[size]} 
        />
      )}
      
      <span
        className={`inline-block min-w-[5ch] text-right font-mono tabular-nums ${sizeClasses[size]} ${
          isExpired
            ? 'text-red-600 font-bold'
            : theme === 'dark'
              ? 'text-white'
              : 'text-black'
        }`}
      >
        {formatTime(time)}
      </span>
      
      <button
        onClick={onToggle}
        className={`${buttonSizeClasses[size]} rounded ${
          isRunning 
            ? 'bg-red-500 hover:bg-red-600' 
            : 'bg-green-500 hover:bg-green-600'
        } text-white`}
      >
        {isRunning ? <Pause size={iconSizes[size]} /> : <Play size={iconSizes[size]} />}
      </button>

      {onReset && (
        <button
          onClick={onReset}
          className={`${buttonSizeClasses[size]} rounded bg-gray-500 hover:bg-gray-600 text-white text-xs`}
          title="Reset"
        >
          Reset
        </button>
      )}
    </div>
  );
};

export default Timer;